import apiClient from '../client'

export const planService = {
  list: async (params = {}) => {
    const response = await apiClient.get('/plans', { params })
    return response.data
  },

  getById: async (planId) => {
    const response = await apiClient.get(`/plans/${planId}`)
    return response.data
  },

  create: async (payload) => {
    const response = await apiClient.post('/plans', payload)
    return response.data
  },

  update: async (planId, payload) => {
    const response = await apiClient.patch(`/plans/${planId}`, payload)
    return response.data
  },

  delete: async (planId) => {
    const response = await apiClient.delete(`/plans/${planId}`)
    return response.data
  },
}
